import { CalendarDay, CalendarMonth, CalendarYear } from '@rehookify/datepicker';
import clsx from 'clsx';
import { TCalendarData, TPropsGetters } from './date-time.types';

export const getDayClassName = (
  { now, selected, inCurrentMonth, range }: CalendarDay,
  ...classNames: string[]
) =>
  clsx(
    'day',
    range,
    {
      selected,
      today: now,
      secondary: !inCurrentMonth,
    },
    ...classNames,
  );

export const getMonthClassName = (month: CalendarMonth) =>
  clsx('month', {
    active: month.active,
    disabled: month.disabled,
    selected: month.selected,
    now: month.now,
  });

export const getYearsClassName = (year: CalendarYear) =>
  clsx('year', {
    active: year.active,
    disabled: year.disabled,
    selected: year.selected,
    now: year.now,
  });

export const panelOrderTypes = ['date', 'month', 'year'] as const;
export const panelOrders = Array.from(panelOrderTypes);
export type TPanelMode = typeof panelOrderTypes[number];

export const getNextMode = (current: TPanelMode): TPanelMode => {
  const index = panelOrders.findIndex((m) => m === current);

  return panelOrders[(index + 1) % panelOrders.length];
};

const modesActions: Record<
  TPanelMode,
  ('previousMonthButton' | 'nextMonthButton' | 'previousYearsButton' | 'nextYearsButton')[]
> = {
  date: ['previousMonthButton', 'nextMonthButton'],
  month: ['previousMonthButton', 'nextMonthButton'],
  year: ['previousYearsButton', 'nextYearsButton'],
};

export const getActionsForMode = (current: TPanelMode, getters: TPropsGetters) => {
  return modesActions[current].map((a) => getters[a]);
};

export const getHeaderForMode = (
  data: TCalendarData,
  mode: TPanelMode,
  calendarIndex: number = 0,
) => {
  switch (mode) {
    case 'date':
    case 'month':
      return {
        month: data.calendars[calendarIndex].month,
        year: data.calendars[calendarIndex].year,
      };
    case 'year':
      return { year: `${data.years[0].value}-${data.years[data.years.length - 1].value}` };
    default:
      return null;
  }
};

export function getDateFormat(mode: TPanelMode | 'full', locale: string) {
  switch (mode) {
    case 'date':
    case 'full':
      return locale === 'sk' || 'cz' ? 'DD.MM.YYYY' : 'MM/DD/YYYY';
    case 'month':
      return locale === 'sk' || 'cz' ? 'MM.YYYY' : 'MM/YYYY';
    case 'year':
      return 'YYYY';
    default:
      break;
  }
}
